const storeTrendingDataReducer = data => {
  return data;
};

export default storeTrendingDataReducer;
